import { defineComponent } from "vue";
export default defineComponent({
  name: "digitalProductLicenseAgreement",
  components: {},
  setup() {
    return {};
  }
});